import React, { Dispatch, SetStateAction, useState } from "react";

import { PublicationListSearchFilterType } from "@/components/business/PublicationListContainer/publicationList.types";
import SearchInput from "@atoms/SearchInput/SearchInput";
import { usePublicationListFilterState } from "@stores/publicationList";

import {
  PUBLICATION_LIST_EDITOR_INFO_FILTER,
  PUBLICATION_LIST_EDITOR_INFO_FILTER_KEY,
} from "./constants/editorInfoFilter.constants";
import * as S from "./EditorInfoSearch.style";
import PublicationSearchFilterSelect from "../PublicationInfoSearch/components/PublicationSearchFilterSelect/PublicationSearchFilterSelect";

interface Props {
  currentEditorFilter: PublicationListSearchFilterType;
  setCurrentFilter: Dispatch<SetStateAction<PublicationListSearchFilterType>>;
}

const EditorInfoSearch = ({ currentEditorFilter, setCurrentFilter }: Props) => {
  const [publicationListFilter, setPublicationListFilter] =
    usePublicationListFilterState();
  const [typing, setTyping] = useState("");

  const { search } = publicationListFilter;

  const handleSearchKeyboard = () => {
    const currentInput = typing.trim();

    const newSearch = { ...search };
    PUBLICATION_LIST_EDITOR_INFO_FILTER_KEY.forEach((key) => {
      delete newSearch[key];
    });

    newSearch[currentEditorFilter.key] = currentInput;

    if (currentInput) {
      setPublicationListFilter({
        ...publicationListFilter,
        search: newSearch,
        page: 1,
      });
    }
  };

  const handleSearchButton = () => {
    const currentInput = typing || search?.[currentEditorFilter.key];

    const newSearch = { ...search };
    PUBLICATION_LIST_EDITOR_INFO_FILTER_KEY.forEach((key) => {
      delete newSearch[key];
    });

    newSearch[currentEditorFilter.key] = currentInput;

    if (currentInput) {
      setPublicationListFilter({
        ...publicationListFilter,
        search: newSearch,
        page: 1,
      });
    }
  };

  return (
    <S.EditorInfoSearchWrapper>
      <PublicationSearchFilterSelect
        subTitle="Editor Filter"
        filterList={PUBLICATION_LIST_EDITOR_INFO_FILTER}
        currentFilter={currentEditorFilter}
        setCurrentFilter={setCurrentFilter}
        isEditor
      />
      <S.EditorInfoSearchTitle>
        <SearchInput
          placeholder="Search Editors"
          onSearchButton={handleSearchButton}
          handleSearchKeyboard={handleSearchKeyboard}
          typing={typing}
          setTyping={setTyping}
        />
      </S.EditorInfoSearchTitle>
    </S.EditorInfoSearchWrapper>
  );
};

export default EditorInfoSearch;
